<div class="card card-custom" [ngClass]="{ 'card-body-progress': viewLoading }">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <div class="card-body">
    <div class="card-body-progress">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>

    <div class="form-section form-section-first">
      <div class="form-group">
        <mat-form-field appearance="fill" class="example-full-width">
          <mat-label translate="PHARMACY_GROUP_DRUG.FORM.SEARCH_DRUGS">Search Drugs</mat-label>
          <input matInput [matAutocomplete]="auto" [formControl]="drugInput" />
        </mat-form-field>
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="selectedDrug($event.option.value)"
        >
          <mat-option *ngFor="let drug of filteredDrugs | async" [value]="drug">
            <span
              >{{ drug.drug }} | <small>NDC: {{ drug.ndc }}</small></span
            >
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="form-group" *ngIf="selectedDrugs">
        <mat-selection-list (selectionChange)="removeDrug($event.option.value)">
          <mat-list-option [value]="drug" *ngFor="let drug of selectedDrugs" selected="true">
            <span
              >{{ drug.drug }} | <small>NDC: {{ drug.ndc }}</small></span
            >
          </mat-list-option>
        </mat-selection-list>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button
          type="button"
          mat-raised-button
          cdkFocusInitial
          (click)="onNoClick()"
          matTooltip="Cancel changes"
        >
          <span translate="GLOBAL.CANCEL">Cancel</span></button
        >&nbsp;
        <button
          type="submit"
          mat-raised-button
          color="primary"
          (click)="closeDialog()"
          [disabled]="viewLoading"
          matTooltip="Submit"
        >
          <span translate="GLOBAL.SAVE">Save</span>
        </button>
      </div>
    </div>
  </div>
</div>
